import { Component, OnInit, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/userService/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: 'app-detailsproductreview',
  templateUrl: './detailsproductreview.component.html',
  styleUrls: ['./detailsproductreview.component.css']
})

export class DetailsproductreviewComponent implements OnInit {
  isCollapsed: boolean = false;
  permission: any;
  userRId: any;
  id: any;
  formdata: any = [];
  paydata: any = [];
  UpDoc: any;
  clientContact: any = [];
  commercialdata: any = [];
  warrantydata: any = [];
  guaranteedata: any = [];
  supplierdata: any = [];
  requirementdata: any = [];
  contractdata: any = [];
  creditdata: any = [];
  itemData: any = [];
  totalData: any = [];
  payFormdata: any = [];
  CPoCListdata: any = [];
  CPoCDetaildata: any = [];
  currentPage: any = 0;
  pageSize: any = 10;
  searchword: any = '';
  orderActivityHistory: any = [];
  NextPageNo: any;
  showMore: any;
  loader: boolean = false;
  item: any = [];
  currency: any = [];
  activeTab: string = "tab-selectbyid9";
  Status: any;
  Modulepermi: any;
  userId: any;
  modalRef: BsModalRef;

  constructor(
    private UserService: UserService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService,
  ) {
    this.activeTab = localStorage.getItem("activeId");
  }

  ngOnInit(): void {
    this.isCollapsed = false;
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    let UserId = localStorage.getItem('userId');
    this.userId = this.UserService.decryptData(UserId);
    let modulePermi = JSON.parse(localStorage.getItem('ModulePermission'));
    this.Modulepermi = this.UserService.decryptData(modulePermi);
    if (this.permission.OrderReview_View != 1 && this.userRId != 1) {
      if (this.permission.OrderReview_Edit != 1 && this.userRId != 1) {
        if (this.Modulepermi.OrderReview == 1) {
          this.toastr.error('You do not have permission');
          this.router.navigate(['/orderReview/orderreview']);
        }
        else {
          this.toastr.error('You do not have permission');
          this.router.navigate(['/profile']);
        }
        return;
      }
    }
    let decid = this.route.snapshot.params['id'];
    decid = decid.toString().replace('Ar1t', '=').replace('FGH', '/').replace('THD', '+');
    this.id = this.UserService.decryptData(decid);
    localStorage.setItem('editOid', decid);

    let data = {
      "OrderInfoId": this.id,
      "Mode": "View"
    }
    this.spinner.show();
    this.UserService.GetOrderReviewDetailById(data).subscribe(res => {
      if (res['result'] == 'Success') {
        this.spinner.hide();
        this.formdata = res['OrderInformation'];
        this.clientContact = res['ClientPointOfContact'][0];
        this.commercialdata = res['CommercialInformation'];
        this.payFormdata = res['PaymentTermInformation'];
        this.paydata = res['PaymentTermList'];
        this.warrantydata = res['WarrantyList'];
        this.guaranteedata = res['GauranteeList'];
        this.supplierdata = res['SupplierList'];
        this.contractdata = res['SubContractorList'];
        this.creditdata = res['CreditSplitList'];
        this.requirementdata = res['SpecialProjectRequirement'];
        this.UpDoc = res['UploadDocument'];
        this.itemData = res['ItemDescription'].filter(item => item.OrderQuantity > 0);
        this.totalData = res['ItemDescriptionTotal'];
        this.currency = res['OrderInformation']['currencyName'];
        this.Status = res['OrderInformation']['CurrentStageName'];
        this.CPoCListdata = res['ClientPointOfContactList'];
      }
      else if (res['result'] == 'Failed') {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
        this.router.navigate(['/profile']);
      } else {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
      }
    }, (err) => {
      this.spinner.hide();
      if (err && (err.Msg || err.Message)) {
        this.toastr.error(err.Msg || err.Message);
      }      
    })

    let historydata = {
      "OrderInfoId": this.id,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
      "SearchWord": this.searchword,
    }

    this.UserService.OrderActivityHistory(historydata).subscribe(res => {
      if (res['result'] == 'success') {
        this.orderActivityHistory = res['Data'];
        this.showMore = res['NextPage'];
        this.NextPageNo = res['NextPageNo'];
      }
    })

  }

  formatNumber(value: number, decimalPlaces: number): string {
    const roundedValue = Math.floor(value * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
    return roundedValue.toFixed(decimalPlaces);
  }

  edit(id) {
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid.toString().replace('=', 'Ar1t').replace('/', 'FGH').replace('+', 'THD');
    this.router.navigate(['/orderReview/editproductreview', encryptid]);
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed
  }

  showMoreactivity() {
    let data = {
      "OrderInfoId": this.id,
      "ItemPerPages": this.pageSize,
      "PageNo": this.NextPageNo,
      "SearchWord": this.searchword,
    }
    this.loader = true;
    this.UserService.OrderActivityHistory(data).subscribe(res => {
      this.spinner.show();
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.loader = false;
        res['Data'].forEach(element => {
          this.orderActivityHistory.push(element);
        });
        this.showMore = res['NextPage'];
      } else if (res['result'] == 'Failed') {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Message']);
        this.spinner.hide();
      }
    });
  }

  tabclick1(id) {
    localStorage.setItem("active_id", "tab-selectbyid91");
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid.toString().replace("=", "Ar1t").replace("/", "FGH").replace("+", "THD");
    this.router.navigate(["/orderReview/detailsproductreview",encryptid,"detailattachment"]);
  }

  tabclick(id) {
    localStorage.setItem("active_id", "tab-selectbyid10");
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid.toString().replace("=", "Ar1t").replace("/", "FGH").replace("+", "THD");
    this.router.navigate(["/orderReview/detailsproductreview",encryptid,"detailapprovepdf"]);
  }

  tabclick2(id) {
    localStorage.setItem("active_id", 'tab-selectbyid9');
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid.toString().replace("=", "Ar1t").replace("/", "FGH").replace("+", "THD");
    this.router.navigate(["/orderReview/detailsproductreview", encryptid]);
  }

  viewCPoCDetail(template: TemplateRef<any>, eid) {
    let data = {
      "ContactId": eid
    }
    this.spinner.show();
    this.UserService.GetEditContactDetail(data).subscribe(res => {
      this.spinner.hide();
      if (res['result'] == 'success') {
        this.CPoCDetaildata = res['Data'];
        this.modalRef = this.modalService.show(template, {
          class: "modal-dialog-centered CutomModalSize modal-lg",
          backdrop: "static",
          ignoreBackdropClick: true,
          keyboard: false,
        });
      }
      else if (res['result'] == 'Failed') {
        this.toastr.error(res['Msg']);
      } else {
        this.toastr.error(res['Msg']);
      }
    }, (err) => {
      this.spinner.hide();
      if (err && (err.Msg || err.Message)) {
        this.toastr.error(err.Msg || err.Message);
      }      
    })
  }

}
